import { AlertProps, Alert as SporStaticAlert } from "@vygruppen/spor-react";
import { useThemeOrSemantic } from "shared/theme/themeSemantic";
import { variantToSemantics } from "shared/utils/semantics";

export const InternalDropsStaticAlert = ({
  variant,
  children,
  ...rest
}: AlertProps) => {
  const theme = useThemeOrSemantic(variantToSemantics(variant));
  return (
    <SporStaticAlert
      variant={variant}
      background={theme.colorSemanticFillPulse}
      {...rest}
    >
      {children}
    </SporStaticAlert>
  );
};
